import YieldingoForm from './yieldingoForm';

window.addEventListener('load', () => {
	const yieldingoForm = document.getElementById('yieldingo-form') as HTMLFormElement;
	if (yieldingoForm) {
		const form = new YieldingoForm(yieldingoForm);
		form.init();
	}
	const yieldingoSubmissionForm = document.getElementById('yieldingo-form-submission') as HTMLFormElement;
	if (yieldingoSubmissionForm) {
		const submitBtn = yieldingoSubmissionForm.querySelector('.yieldingo-form-submit-button') as HTMLButtonElement;
		const emailField = yieldingoSubmissionForm.querySelector('#yieldingo-email') as HTMLInputElement;
		const companyField = yieldingoSubmissionForm.querySelector('#yieldingo-company') as HTMLInputElement;
		const revenueField = yieldingoSubmissionForm.querySelector('#yieldingo-revenue') as HTMLInputElement;
		const marginField = yieldingoSubmissionForm.querySelector('#yieldingo-margin') as HTMLInputElement;
		const optionalWrapper = yieldingoSubmissionForm.querySelector('.yieldingo-form-optional') as HTMLDivElement;
		const figuresCheckbox = yieldingoSubmissionForm.querySelector('#yieldingo-figures') as HTMLInputElement;
		const formFieldsWrapper = yieldingoSubmissionForm.querySelector('.yieldingo-form-fields-wrapper') as HTMLDivElement;

		if (figuresCheckbox.checked) {
			formFieldsWrapper.classList.add('show');
		} else {
			formFieldsWrapper.classList.remove('show');
		}
		figuresCheckbox.addEventListener('change', () => {
			if (figuresCheckbox.checked) {
				formFieldsWrapper.classList.add('show');
			} else {
				formFieldsWrapper.classList.remove('show');
			}
			validateAllInputs();
		});

		const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

		validateAllInputs();

		emailField.addEventListener('input', () => {
			validateAllInputs();
		});
		companyField.addEventListener('input', () => {
			validateAllInputs();
		});
		marginField.addEventListener('input', () => {
			validateAllInputs();
		});
		revenueField.addEventListener('input', () => {
			validateAllInputs();
		});

		const marginMin = parseInt(marginField.min);
		const marginMax = parseInt(marginField.max);
		const formatMarginField = (value: number | null = null) => {
			if (!marginField.value && value === null) {
				return;
			}
			const number = value ?? parseFloat(marginField.value.replace(',', '.').replace('%', '').trim());
			console.log(number, marginField.value, marginField.value.replace(',', '.').replace('%', '').trim());
			if (isNaN(number)) {
				return;
			}
			marginField.value = (number / 100).toLocaleString(undefined, {
				style: 'percent',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		};
		marginField.addEventListener('change', () => {
			if (marginField.value) {
				// Limit value between min and max
				const valueNormalized = parseFloat(marginField.value.replace(',', '.').replace('%', '').trim());
				formatMarginField(
					Math.max(
						marginMin,
						Math.min(
							valueNormalized,
							marginMax,
						),
					),
				);
			}
		});
		formatMarginField();

		function checkMarginForecastFields(): boolean {
			console.log(
				marginField.value,
				revenueField.value,
				marginField.checkValidity(),
				revenueField.checkValidity());
			return !figuresCheckbox.checked || (
				marginField.value &&
				revenueField.value &&
				marginField.checkValidity() &&
				revenueField.checkValidity()
			);
		}

		function validateAllInputs() {
			let emailValid = false;
			let companyValid = false;
			if (emailField.value) {
				if (!emailField.value.match(emailRegex)) {
					emailField.setCustomValidity('Invalid email');
				} else {
					emailField.setCustomValidity('');
					emailValid = true;
				}
			}

			if (companyField.value) {
				companyValid = companyField.checkValidity();
			}

			if (emailValid && companyValid) {
				optionalWrapper.classList.add('show');
				submitBtn.disabled = !checkMarginForecastFields();
			} else {
				optionalWrapper.classList.remove('show');
				submitBtn.disabled = true;
			}
		}
	}
});
